import React from "react";

export class PanelFooter extends React.Component {
    render() {
        return (
            <div className={"panel-footer"}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/panel/PanelFooter.js